import { render, staticRenderFns } from "./NhlStartGoalies.vue?vue&type=template&id=e3443418&scoped=true"
import script from "./NhlStartGoalies.vue?vue&type=script&lang=js"
export * from "./NhlStartGoalies.vue?vue&type=script&lang=js"
import style0 from "./NhlStartGoalies.vue?vue&type=style&index=0&id=e3443418&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3443418",
  null
  
)

export default component.exports